import { useSelector } from "react-redux";
import { Navigate } from "react-router";
import { EXTERNAL_LOGIN_URL } from "../../../../consts";
import { getLoggedIn } from "../../../../store/selectors";
import { getIsIpDomain } from "../../../../utils";

const isIpDomain = getIsIpDomain();

const RedirectLogin = () =>
  (!useSelector(getLoggedIn) && (
    <Navigate to={isIpDomain ? "/login" : EXTERNAL_LOGIN_URL} />
  )) ||
  null;

export default RedirectLogin;
